import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64px",
  height: "64px",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E24329",
      d: "M21.6345 9.99964L21.6064 9.92803L18.8935 2.84781C18.8383 2.70904 18.7406 2.59132 18.6143 2.51154C18.488 2.43312 18.3406 2.39535 18.1922 2.40333C18.0437 2.41131 17.9012 2.46466 17.784 2.55617C17.6681 2.65031 17.5841 2.77787 17.5433 2.92149L15.7114 8.52589H8.29392L6.46211 2.92149C6.42238 2.77709 6.33813 2.64889 6.22133 2.55513C6.10414 2.46362 5.96168 2.41027 5.81321 2.40229C5.66473 2.39431 5.51738 2.43208 5.39105 2.5105C5.26508 2.5906 5.16743 2.70822 5.11187 2.84677L2.39373 9.92388L2.36675 9.99549C1.97621 11.0159 1.928 12.1356 2.2294 13.1859C2.5308 14.2361 3.16546 15.1598 4.03769 15.8178L4.04703 15.8251L4.07194 15.8427L8.20467 18.9376L10.2492 20.4851L11.4947 21.4254C11.6403 21.536 11.8182 21.5958 12.0011 21.5958C12.184 21.5958 12.3619 21.536 12.5076 21.4254L13.753 20.4851L15.7976 18.9376L19.9552 15.8241L19.9656 15.8158C20.8359 15.1576 21.4691 14.2348 21.77 13.186C22.0709 12.1372 22.0234 11.0191 21.6345 9.99964Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FC6D26",
      d: "M21.6344 9.99965L21.6064 9.92804C20.2844 10.1994 19.0388 10.7593 17.9583 11.5678L12 16.0732C14.029 17.6081 15.7954 18.9418 15.7954 18.9418L19.9531 15.8282L19.9634 15.8199C20.835 15.1618 21.4691 14.2384 21.7705 13.1887C22.0718 12.139 22.0241 11.0198 21.6344 9.99965Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FCA326",
      d: "M8.20459 18.9418L10.2492 20.4892L11.4946 21.4295C11.6403 21.5401 11.8181 21.6 12.0011 21.6C12.184 21.6 12.3618 21.5401 12.5075 21.4295L13.7529 20.4892L15.7975 18.9418C15.7975 18.9418 14.029 17.604 12 16.0732C9.97101 17.604 8.20459 18.9418 8.20459 18.9418Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FC6D26",
      d: "M6.04075 11.5678C4.96117 10.7576 3.71575 10.1963 2.39373 9.92389L2.36675 9.9955C1.97621 11.0159 1.928 12.1357 2.2294 13.1859C2.5308 14.2361 3.16546 15.1598 4.03769 15.8178L4.04703 15.8251L4.07194 15.8428L8.20467 18.9376C8.20467 18.9376 9.96902 17.604 12.0001 16.069L6.04075 11.5678Z"
    }, null, -1)
  ]))]))
}
export default { render: render }